/**
 * Help Center Routes
 * Available to all authenticated users regardless of role.
 */

import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { LazyPage } from "../helpers";

const HelpCenterPage = lazy(() =>
  import("@/pages/help/HelpCenterPage").then((m) => ({
    default: m.HelpCenterPage,
  }))
);

const HelpArticlePage = lazy(() =>
  import("@/pages/help/HelpArticlePage").then((m) => ({
    default: m.HelpArticlePage,
  }))
);

export const helpRoutes: RouteObject[] = [
  {
    path: "/help",
    element: (
      <ProtectedRoute>
        <AppShell>
          <LazyPage>
            <HelpCenterPage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/help/:slug",
    element: (
      <ProtectedRoute>
        <AppShell>
          <LazyPage>
            <HelpArticlePage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
];
